import { EmoticonConfusedOutlineIcon } from './EmoticonConfusedOutlineIcon';

/**
 * author: Michael Richins
 * id CB195387-50AC-46A3-B1C4-F3DA96E0EE42
 * name emoticon-confused-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-confused-outline.svg
 * tags
 * - Emoji 
 */
export const FaceConfusedOutlineIcon = EmoticonConfusedOutlineIcon;
export default FaceConfusedOutlineIcon